import React, { useRef, useState } from 'react'
import styled from 'styled-components';
import ToggleSection from './ToggleSection';
import EditIcon from './icons/EditIcon';
import { Color, Colors } from '../styles/Colors';
import AddIcon from './icons/AddIcon';
import CheckmarkIcon from './icons/CheckmarkIcon';
import DeleteIcon from './icons/DeleteIcon';
import { ExpandTextArea } from '../styles/FormStyle';
import CloseIcon from './icons/CloseIcon';

/* Table created with flex  */
export const Table = styled.div`
  & > h5 {
    padding: 2rem 0 0 0; 
  }

  /* Create table (head and data) with flex */
  & > div {
    display: flex; 
    gap: 0.5rem; 
    padding: 1rem 0 1rem 1rem; 
    
    & > div {
      flex: 1; 
    }
      
    & > div:nth-of-type(1) {
      flex: 3; 
    }
  }

  /* Target paragraphs in table header */ 
  & > div:first-of-type {
    & > div {
      & > p {
        font-weight: 600; 
      }
    }
  }

  /* Target table data */
  & > div:not(:first-child){
    &:nth-of-type(even) {
      background-color: rgba(216, 216, 216, 0.5);  
    }
    
    /* Target all paragraphs in the first column of all table rows */
    & > div:first-child {
      & > p {
        padding-bottom: 0.5rem; 
      }

      & > p:last-of-type {
        padding: 0; 
      }
    }
  }; 
`;

const ReplaceWrapper = styled.div`
  padding: 0.5rem 0 0 0; 
`;

const EnTitleComment = styled.p`
    font-weight: 600; 
`;

const EnParagraphComment = styled.p`
    margin: 0 0 1rem 0; 
`;

const TextAreaWrapper = styled.div`
    textarea {
        background-color: ${Color(Colors.blue)};  
        color: ${Color(Colors.white)}; 
        border: none; 
    }; 

    textarea::placeholder {
        color: rgba(255, 255, 255, 0.8);
    }; 
    
    textarea:focus {
        outline: ${`2px solid ${Color(Colors.white)}`};  
    }; 
`;

const ButtonsWrapper = styled.div`
    display: flex; 
    padding: 0 0 0.5rem 0; 
`;

const Button = styled.button`
    background: none; 
    border: none; 
    background-color: ${Color(Colors.blue)};  
    width: 38px; 
    height: 38px; 
    border-radius: 4px;
    margin: 0 0.5rem 0 0; 

    &:hover {
        background-color: ${Color(Colors.lightBlue)};
    }
`;

const ExpandableReportTable = ({ data, type, title, moduleId, isEditable = false, onChangeItem }) => {
    const [editingId, setEditingId] = useState(null);
    const [draftComments, setDraftComments] = useState({});
    const [height, setHeight] = useState(100);
    const textareaRef = useRef(null);

    const handleSaveComment = (d) => {
        const comment = (draftComments[d.id] ?? '').trim();

        if (!comment) {
            setEditingId(null);
            return;
        };

        onChangeItem({
            ...d,
            comment: comment
        });

        setEditingId(null);
    };

    const handleDeleteComment = (d) => {

        onChangeItem({
            ...d,
            comment: '',
        });

        setDraftComments((prev) => ({
            ...prev,
            [d.id]: '',
        }));

        setEditingId(null);
    };

    const handleCloseComment = (d) => {
        setEditingId(null);
    };

    const handleEditComment = (d) => {
        setDraftComments((prev) => ({
            ...prev,
            [d.id]: d.comment ?? ''
        }))
        setEditingId(d.id);
    };


    const handleMouseDown = (event) => {
        const startY = event.clientY;
        const startHeight = textareaRef.current.offsetHeight;

        const onMouseMove = (e) => {
            const newHeight = startHeight + (e.clientY - startY);
            // Set a minimum height if desired
            if (newHeight > 50) {
                setHeight(newHeight);
            }
        };

        const onMouseUp = () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    };


    return (
        <ToggleSection
            title={title}
            type={type}
            moduleId={moduleId}
        >
            <div>
                <Table>
                    <div>
                        <div>
                        </div>
                        <div><p>Språk</p></div>
                        <div><p>Överens-kommelse</p></div>
                        <div><p>Antal sidor</p></div>
                        <div>
                            <p>
                                {type === 'publish'
                                    ? 'Fastställelse-datum'
                                    : 'Upphävande-datum'
                                }
                            </p>
                        </div>
                    </div>
                    {
                        data?.map((d, index) => (
                            <div key={index}>
                                <div>
                                    <p style={{ fontWeight: 600, textDecoration: 'underline' }}>{`SEK ${d.committee_sek?.name ?? ''} ${d.committee_sek?.title ?? ''}`}</p>
                                    <p style={{ textDecoration: 'underline' }}>{d.sek ?? d.name ?? ''}</p>
                                    <p>{d.title_sv ?? ''}</p>
                                    <p>{d.title_en_us ?? ''}</p>
                                    {isEditable && (
                                        <>
                                            <EnTitleComment 
                                                style={{
                                                    padding: 
                                                        ((editingId !== d.id) && !draftComments[d.id]) || 
                                                        ((editingId !== d.id) && (draftComments[d.id])) 
                                                            ? '0 0 0.75rem 0' 
                                                            : '0' 
                                                }}
                                            >
                                                Kommentar: 
                                            </EnTitleComment>

                                            {editingId === d.id ? (
                                                <>
                                                    <TextAreaWrapper>
                                                        <ExpandTextArea onMouseDown={handleMouseDown}>
                                                            <textarea
                                                                type='text'
                                                                value={draftComments[d.id] ?? d.comment ?? ''}
                                                                placeholder='Lägg till kommentar...'
                                                                onChange={(event) => {
                                                                    setDraftComments((prev) => ({
                                                                        ...prev,
                                                                        [d.id]: event.target.value
                                                                    }))
                                                                }}
                                                                ref={textareaRef}
                                                                style={{ height: `${height}px`, resize: 'none', padding: '8px' }}
                                                                spellCheck={false}
                                                            ></textarea>
                                                            <div></div>
                                                        </ExpandTextArea>
                                                    </TextAreaWrapper>
                                                    <ButtonsWrapper>
                                                        {String(draftComments[d.id] ?? '').trim() && (
                                                            <>
                                                                <Button
                                                                    onClick={() => handleSaveComment(d)}
                                                                >
                                                                    <CheckmarkIcon
                                                                        fill={Color(Colors.white)}
                                                                        height='18px'
                                                                        width='18px'
                                                                    />
                                                                </Button>
                                                                <Button onClick={() => handleDeleteComment(d)}>
                                                                    <DeleteIcon
                                                                        fill={Color(Colors.white)}
                                                                        height='18px'
                                                                        width='18px'
                                                                    />
                                                                </Button>
                                                            </>
                                                        )}
                                                        <Button
                                                            onClick={() => handleCloseComment(d)}
                                                        >
                                                            <CloseIcon
                                                                fill={Color(Colors.white)}
                                                                height='26px'
                                                                width='26px'
                                                            />
                                                        </Button>
                                                    </ButtonsWrapper>
                                                </>
                                            ) : (
                                                <>
                                                    {d.comment && <EnParagraphComment>{d.comment}</EnParagraphComment>}
                                                    <ButtonsWrapper>
                                                        <Button onClick={() => handleEditComment(d)}>
                                                            {d.comment
                                                                ? <EditIcon
                                                                    fill={Color(Colors.white)}
                                                                    height='26px'
                                                                    width='26px'
                                                                />
                                                                : <AddIcon
                                                                    fill={Color(Colors.white)}
                                                                    height='26px'
                                                                    width='26px'
                                                                />
                                                            }
                                                        </Button>
                                                        {String(draftComments[d.id] ?? '').trim() && (
                                                            <Button onClick={() => handleDeleteComment(d)}>
                                                                <DeleteIcon
                                                                    fill={Color(Colors.white)}
                                                                    height='22px'
                                                                    width='22px'
                                                                />
                                                            </Button>
                                                        )}
                                                    </ButtonsWrapper>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {d.usedwith && (
                                        <div>
                                            <p style={{ fontWeight: 600, padding: '1rem 0 0 0' }}>Används tillsammans med:</p>
                                            <div>
                                                {d.usedwith.split('\n').map((item, index) => (
                                                    <p key={index}>{item}</p>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {d.replace && (
                                        <ReplaceWrapper>
                                            <h6>Ersätter:</h6>
                                            <p>{d.replace ?? ''}</p>
                                        </ReplaceWrapper>
                                    )}
                                    {d.replacedby && (
                                        <ReplaceWrapper>
                                            <h6>Ersätts av:</h6>
                                            <p>{d.replacedby ?? ''}</p>
                                        </ReplaceWrapper>
                                    )}
                                </div>
                                <div><p>{d.language ?? ''}</p></div>
                                <div><p>{d.conformably ?? ''}</p></div>
                                <div><p>{d.noofpages ?? ''}</p></div>
                                <div>
                                    <p>
                                        {type === 'publish'
                                            ? new Date(d.determinationdate).toLocaleDateString('sv-SE') ?? ''
                                            : new Date(d.annulmentdate).toLocaleDateString('sv-SE') ?? ''
                                        }
                                    </p>
                                </div>
                            </div>
                        ))
                    }
                </Table>
            </div>
        </ToggleSection>
    );
};

export default ExpandableReportTable